import React from 'react';

const InsightCreditPackageFailure: React.FC = () => {
  return (
    <div className="auth multi-step-login">
      <div className="row h-100">
        <div className="col-lg-6 mx-auto">
          <div className="auth-form-light text-left p-5">
            <div className="brand-logo text-center">
              <a href="/">
                <img src="/images/logo.png" alt="logo" />
              </a>
            </div>

            <div className="text-center mb-4">
              <h2 className="text-danger">Payment Failed</h2>
              <div className="error-circle mt-3 mb-4">
                <i className="mdi mdi-close-circle-outline text-danger" style={{ fontSize: '48px' }}></i>
              </div>
              <p className="mb-3">
                We were unable to process your payment for insight credits. Please try again or contact support if the issue persists.
              </p>
            </div>

            <div className="mt-4">
              <div className="d-flex flex-column align-items-center">
                <a
                  href="/shop/insight_credit_packages"
                  className="btn btn-primary btn-lg mb-3"
                >
                  Try Again
                </a>
                <a
                  href="mailto:support@decodeinvesting.com?subject=Payment%20Failed%20for%20Insight%20Credits&body=I%20encountered%20an%20issue%20while%20trying%20to%20purchase%20insight%20credits."
                  className="btn btn-outline-primary btn-lg mb-3"
                >
                  Contact Support
                </a>
                <a
                  href="/dashboard"
                  className="btn btn-outline-secondary btn-lg"
                >
                  Return to Dashboard
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsightCreditPackageFailure;
